<template>
  <social-button :method="method">
    {{ $trlMessage('button.refresh_connection') }}
  </social-button>
</template>

<script>
import SocialButton from '@/shared/legacy/ui/social-button/social-button.vue';

export default {
  name: 'JobsiteConnectionButton',
  components: {
    SocialButton
  },
  props: {
    authType: {
      type: String,
      required: true
    }
  },
  computed: {
    href() {
      return `/account/login/${this.buttonName}`;
    },
    buttonName() {
      return this.authType.toLocaleLowerCase();
    },
    method() {
      return {
        id: this.authType.toLocaleLowerCase(),
        href: window.location.href,
        connect_settings: {
          login_path: `/account/login/${this.buttonName}`
        }
      };
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
